/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 685
// module chunks = 0